import { jsx as m } from "react/jsx-runtime";
import { useState as n } from "react";
import { Avatar as s } from "@chakra-ui/react";
const i = ({ size: o = "md", src: r, ...t }) => {
  const [a, e] = n(!1);
  return /* @__PURE__ */ m(
    s,
    {
      size: o,
      src: r,
      onError: () => e(!0),
      ...r && !a && { background: "none" },
      ...t
    }
  );
};
export {
  i as Avatar
};
